import React, { useState, useEffect } from 'react';
// import Motorbike from './Motorbike.gif';
import './Skeleton.scss';

const Skeleton = () => {
  return <div className="loader"></div>;
};

export default Skeleton;
